import type { ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useCurrentUser } from '../../auth/auth-provider';
import { ProjectsTab } from './projects-tab';
import { VendorsTab } from './vendors-tab';
import { UsersTab } from './users-tab';
import { CategoriesTab } from './categories-tab';
import { DocumentsTab } from './documents-tab';
import { EmployeesTab } from './employees-tab';
import pageStyles from '../../components/layout/page.module.css';
import styles from './settings-page.module.css';

interface Tab {
  id: string;
  label: string;
  adminOnly?: boolean;
  render: () => ReactNode;
}

const TABS: Tab[] = [
  { id: 'budowy', label: 'Budowy', render: () => <ProjectsTab /> },
  { id: 'kontrahenci', label: 'Kontrahenci', render: () => <VendorsTab /> },
  { id: 'kategorie', label: 'Kategorie kosztów', render: () => <CategoriesTab /> },
  { id: 'dokumenty', label: 'Dokumenty', render: () => <DocumentsTab /> },
  { id: 'pracownicy', label: 'Pracownicy', render: () => <EmployeesTab /> },
  { id: 'uzytkownicy', label: 'Użytkownicy', adminOnly: true, render: () => <UsersTab /> },
];

/**
 * Everything that is configured once and then rarely touched.
 *
 * Kept out of the main navigation so the daily queues stay the whole menu, but
 * one click away rather than hidden behind a gear icon nobody finds.
 * The active tab lives in the URL, so a link to a specific list can be shared.
 */
export function SettingsPage() {
  const user = useCurrentUser();
  const [searchParams, setSearchParams] = useSearchParams();

  const available = TABS.filter((tab) => !tab.adminOnly || user.role === 'ADMIN');
  const requested = searchParams.get('zakladka');
  const active = available.find((tab) => tab.id === requested) ?? available[0]!;

  return (
    <>
      <header className={pageStyles.header}>
        <h1 className={pageStyles.title}>Ustawienia</h1>
      </header>

      <nav className={styles.tabs} aria-label="Sekcje ustawień">
        {available.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`${styles.tab} ${tab.id === active.id ? styles.tabActive : ''}`}
            aria-current={tab.id === active.id ? 'page' : undefined}
            onClick={() => setSearchParams({ zakladka: tab.id })}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      {active.render()}
    </>
  );
}
